export default {
    // Common
    'Common.sort': 'Sort',

    // Time
    'Time.from': 'From',
    'Time.to': 'To',
    'Time.setToNow': 'Set to now',

    // Table
    'Table.rowsPerPage': 'Rows per page',
    'Table.of': 'of',

    // General
    'General.console': 'Console',
    'General.logIn': 'Log in',
    'General.logInTitle': 'Log into app',
    'General.username': 'Username',
    'General.username.placeholder': 'Enter your username',
    'General.password': 'Password',
    'General.confirm.password': 'Confirm password',
    'General.password.placeholder': 'Enter password',
    'General.application': 'Space',
    'General.application.placeholder': 'Select space',
    'General.guides': 'Guides',
    'General.guides.placeholder': 'Select guides',
    'General.language.english': 'English',
    'General.language.slovak': 'Slovak',
    'General.createApplication': 'Create space',
    'General.domain': 'Domain',
    'General.domains': 'OriginURLs',
    'General.organizations': 'Organization',
    'General.name': 'Name',
    'General.firstName': 'First name',
    'General.lastName': 'Last name',
    'General.email': 'Email',
    'General.actions': 'Actions',
    'General.search.placeholder': 'Search for spaces',
    'General.identifier': 'Identifier',
    'General.confirm': 'Confirm',

    // Notifications
    'Notification.script.copied': 'Application script was copied',
    'Notification.configuration.copied': 'Configuration was copied',
    'Notification.save': 'Your settings were saved',
    'Notification.apply': 'Your settings were applied',
    'Notification.fail': 'Unable to save, something went wrong',
    'Notification.fail.loadData': 'Unable to load data, something went wrong',
    'Notification.register.user.success': 'User registration has been successful',
    'Notification.register.user.error': "User registration hasn't been successful",
    'Notification.invite.user': 'The user`s invitation has been successful',
    'Notification.guides.update.success': 'The guide has been successfully updated',
    'Notification.guides.update.fail': 'Sorry, unable to update the guide',
    'Notification.guidesRules.update.success': 'The guide rules have been successfully updated',
    'Notification.guidesRules.update.fail': 'Sorry, unable to update the rules of guide',
    'Notification.guides.updateHost.success': 'The guide has been published',
    'Notification.guides.updateHost.fail': 'Sorry, unable to publish guide',
    'Notification.domain.unique': 'Your domain have to be unique',
    'Notification.create.segment': 'Your segment was created',
    'Notification.edit.segment': 'Segment has been updated',
    'Notification.create.guide': 'Your guide was created',
    'Notification.import.success': 'Your import was successful',
    'Notification.import.fail': 'Your import was not successful, something is wrong',
    'Notification.export.success': 'Your export was successful',
    'Notification.export.fail': 'Your export was not successful, something is wrong',
    'Notification.create.journey.success': 'Your journey was created',
    'Notification.create.journey.fail': 'Your journey was not created, something is wrong',
    'Notification.update.journey.success': 'Your journey was updated',
    'Notification.update.journey.fail': 'Your journey was not updated, something is wrong',
    'Notification.delete.journey.success': 'Your journey was deleted',
    'Notification.delete.journey.fail': 'Your journey was not deleted, something is wrong',
    'Notification.create.addOn.success': 'Your add-on was added',
    'Notification.create.addOn.fail': 'Your add-on was not added, something is wrong',
    'Notification.generation.guide.success': 'Guide generation started, check guides in the space later',
    'Notification.generation.guide.fail': 'Guide generation failed',
    'Notification.audience.resetAllFacts.success': 'All rule facts are reset',
    'Notification.audience.resetAllFacts.fail': 'Could not reset facts',
    'Notification.generate.recording.success':
        'Your document generation was successful. Please refresh your the page',
    'Notification.generate.recording.fail': 'Your document generation failed',
    'Notification.download.recording.success': 'Your document download was successful',
    'Notification.download.recording.fail': 'Your document download failed',
    'Notification.duplicate.application.success':
        'Your space was successfully duplicated. Please go through the spaces section',
    'Notification.duplicate.application.fail': 'Your space was not duplicated, something is wrong',
    'Notification.remove.user': 'This user is the owner of this space, therefore cannot be removed',
    'Notification.report.notConfigured':
        'No analytics reports configured - contact your administrator for more information',
    'Notification.theme.clone.success': 'Your theme was cloned',
    'Notification.theme.edit.success': 'Your theme was updated',
    'Notification.theme.delete.success': 'Your theme was deleted',

    // Filters
    'Filter.filters': 'Filters',
    'Filter.configureFilter': 'Configure filter',
    'Filter.saveFilter': 'Save filter',
    'Filter.activeFilters': 'Active criteria',
    'Filter.segments': 'Segments',
    'Filter.country': 'Select attribute',
    'Filter.country.chip': 'Country',
    'Filter.segments.country': 'Name of country',
    'Filter.guide.features': 'Guide features',
    'Filter.guide.features.startedFromContextHelp': 'Only those started from Context Help',
    'Filter.guide.features.doesNotStartedFromContextHelp':
        'Guides do not have to start from contextual help',
    'Filter.guide.features.chip.label': 'Started from Context Help',
    'Filter.guides': 'Guides',
    'Filter.guides.guideName': 'Type name of guide',
    'Filter.guidesHistory': 'Compare guides history',
    'Filter.guidesHistory.filterSubtitle': 'Select historical period', // @TBD
    'Filter.guidesHistory.filterSubtitle2': 'Choose guides you want to compare',
    'Filter.guidesFromHistory': 'Guides from history',
    'Filter.timeRange': 'Time range',
    'Filter.timeRange.quick.tab': 'Quick',
    'Filter.timeRange.relative.tab': 'Relative',
    'Filter.timeRange.absolute.tab': 'Absolute',
    'Filter.timeRange.quick.today': 'Today',
    'Filter.timeRange.quick.thisWeek': 'This week',
    'Filter.timeRange.quick.thisMonth': 'This month',
    'Filter.timeRange.quick.thisYear': 'This year',
    'Filter.timeRange.quick.lastHour': 'Last 1 hour',
    'Filter.timeRange.quick.last4Hours': 'Last 4 hours',
    'Filter.timeRange.quick.last12Hours': 'Last 12 hours',
    'Filter.timeRange.quick.last24Hours': 'Last 24 hours',
    'Filter.timeRange.quick.last7Days': 'Last 7 days',
    'Filter.timeRange.quick.last30Days': 'Last 30 days',
    'Filter.timeRange.quick.last60Days': 'Last 60 days',
    'Filter.timeRange.quick.last90Days': 'Last 90 days',
    'Filter.aBguides': 'A/B Guides',
    'Filter.aBguides.aGuidePlaceholder': 'Name of guide A',
    'Filter.aBguides.bGuidePlaceholder': 'Name of guide B',
    'Filter.aBguides.comparisionLabel': 'Comparison label',
    'Filter.aBguides.vs': 'vs',
    'Filter.sampling': 'Sampling',
    'Filter.timestampRanges': 'Time Ranges',
    'Filter.timestamptRanges.key': 'Key',
    'Filter.timestamptRanges.gte': 'From date',
    'Filter.timestamptRanges.lte': 'To date',
    'Filter.urls': 'Urls',
    'Filter.urls.urlName': 'Choose of url',
    'Filter.relativesElements': 'Elements',

    // Buttons
    'Buttons.cancel': 'Cancel',
    'Buttons.save': 'Save',
    'Buttons.createNewApp': 'Create a space',
    'Buttons.create': 'Create',
    'Buttons.open&install': 'Open & install',
    'Buttons.copyScript': 'Copy script',
    'Buttons.copyConfiguration': 'Copy configuration',
    'Buttons.add': 'Add',
    'Buttons.apply': 'Apply',
    'Buttons.import': 'Import',
    'Buttons.export': 'Export',
    'Buttons.switchActive': 'Active',
    'Buttons.delete': 'Delete',
    'Buttons.perform': 'Perform',
    'Buttons.switchEnable': 'Enable',
    'Buttons.filter': 'Filter',
    'Buttons.registerUser': 'Register user',
    'Buttons.switchAdministrator': 'Administrator',
    'Buttons.switchConfusionEnable': 'Enable confusion model',
    'Buttons.edit': 'Edit',
    'Buttons.openInEditor': 'Open in editor',
    'Buttons.invite': 'Invite',
    'Buttons.publish': 'Publish',
    'Buttons.clone': 'Clone',
    'Buttons.createSegment': 'Create segment',
    'Buttons.unassign': 'Unassign',
    'Buttons.update': 'Update',
    'Buttons.createGuide': 'Create guide',
    'Buttons.applyFilters': 'Apply filters',
    'Buttons.requestAChange': 'Request a change',
    'Buttons.cancel.subscription': 'Cancel my subscription',
    'Buttons.createJourney': 'Create journey',
    'Buttons.clear': 'Clear',
    'Buttons.install': 'Install',
    'Buttons.add.timestampRanges': 'Add values for Time ranges filter',
    'Buttons.generate': 'Generate',
    'Buttons.audience.resetAllFacts': 'Reset all rule facts',
    'Buttons.audience.resetFactsForUser': 'Reset all rule facts for user',

    // Date
    'Date.from': 'Date from',
    'Date.to': 'Date to',

    // Form
    'Form.field.isRequired': 'This field is required',
    'Form.field.isLoading': 'Loading data...',
    'Form.field.isEqualited': 'Item of password and item of confirm Password have to are equals',
    'Form.field.email': 'The input is not valid E-mail!',
    'Form.field.invalidHost': 'Invalid host',
    'Form.passwordRequirementsFail': 'Does not meet the password requirements',
    'Form.passwordMustContain': 'Must contain at least',
    'Form.character': 'character',
    'Form.characters': 'characters',
    'Form.upperCaseCharacter': 'uppercase character',
    'Form.number': 'number',
    'Form.passwordInconsistent': 'Two passwords that you enter is inconsistent!',

    // Nav items
    'Navigation.applications': 'Spaces',
    'Navigation.accounts': 'Accounts',
    'Navigation.dashboard': 'Dashboard',
    'Navigation.analytics': 'Analytics',
    'Navigation.settings': 'Settings',
    'Navigation.guides': 'Guides',
    'Navigation.user.profile': 'Profile',
    'Navigation.logout': 'Log out',
    'Navigation.audit': 'Audit',

    // Applications List
    'Applications.list.empty': 'Go ahead and create your first space',

    // Applications menu
    'Applications.navigation.detail.guides': 'Guides',
    'Applications.navigation.detail.settings': 'Settings',
    'Applications.navigation.detail.contextHelp': 'Context help',
    'Applications.navigation.detail.journeys': 'Journeys',
    'Applications.navigation.detail.segments': 'Segments',
    'Applications.navigation.detail.audience': 'Audience',
    'Applications.navigation.detail.analytics': 'Analytics',
    'Applications.navigation.detail.adopt10.contentCloud': 'Content Cloud',
    'Applications.navigation.detail.adopt10.splitScreen': 'Split Screen',
    'Applications.navigation.detail.adopt10.smartPages': 'Smart Pages',
    'Applications.navigation.detail.adopt10.tooltips': 'Tooltips',
    'Applications.navigation.detail.themes': 'Themes',

    // Accounts menu
    'Accounts.navigation.detail.settings': 'Settings',

    // Register user
    'Accounts.register.user': 'User registration',

    // Accounts/Settings menu
    'Accounts.settings.navigation.general': 'General',
    'Accounts.settings.navigation.password': 'Password',
    'Accounts.settings.navigation.billing': 'Billing',
    'Accounts.settings.createSubscription': 'Create Subscription',
    'Accounts.settings.navigation': 'Invoices',

    // Accounts/Settings/General
    'Accounts.settings.general.userName': 'User name',
    'Accounts.settings.general.firstName': 'First name',
    'Accounts.settings.general.lastName': 'Last name',
    'Accounts.settings.general.createdAt': 'Created at',
    'Accounts.settings.general.label': 'Finwe',

    // Accounts/Settings/Billing
    'Accounts.settings.billing.subscription': 'Subscription',
    'Accounts.settings.billing.currentPlan': 'Current plan',
    'Accounts.settings.billing.currentUsage': 'Current usage',
    'Accounts.settings.billing.activeUsers': 'active users per month',
    'Accounts.settings.billing.billingDetails': 'Billing details',
    'Accounts.settings.billing.paymentMethod': 'Payment method',
    'Accounts.settings.billing.nextBillingDate': 'Next billing date',
    'Accounts.settings.billing.billingCountry': 'Billing country',
    'Accounts.settings.billing.cancelSubscription': 'Need to cancel your subscription?',
    'Accounts.settings.billing.cancelSubscription.message': 'We are sad to see you go.',

    // Accounts/Settings/Invoices
    'Accounts.settings.invoices': 'Invoices',
    // Table
    'Accounts.settings.invoices.number': 'Number',
    'Accounts.settings.invoices.billingDate': 'Billing date',
    'Accounts.settings.invoices.amount': 'Amount',
    'Accounts.settings.invoices.status': 'Status',

    // Guides
    'Guides.duplicateGuideWarningTitle': 'Guide contains rules',
    'Guides.duplicateGuideWarningContent':
        'Guide you are trying to duplicate contains rules with relation to other guides.',
    'Guides.list.empty': 'Go ahead and create your first guide',
    'Guides.list.noResults': 'There are no guides for given search criteria',
    'Guides.rules': 'Rules',
    'Guides.access': 'Access',
    'Guides.general': 'General',
    'Guides.pluginConfiguration': 'Plugin configuration',
    'Guides.message2': 'Copy and paste this code to the browser extension',
    'Guides.menuItem.tour': 'Tour',
    'Guides.menuItem.tour.tooltip':
        'Tour is a series of sequential steps leading the user through important points of the space.',
    'Guides.journey': 'Journey',
    'Guides.context': 'Context',
    'Guides.menuItem.recording': 'Capture',
    'Guides.menuItem.recording.tooltip':
        'Capture holds tour snapshots from specific time in the form of various outputs like documents, animations or videos.',
    'Guides.menuItem.playlist': 'Playlist',
    'Guides.menuItem.playlist.tooltip':
        'Embed guidance & support materials such as PDF & videos within Playlists, that can be accessed by users via the Context Help panel.',
    'Guides.menuItem.interaction.collector': 'Interaction Collector',
    'Guides.menuItem.interaction.collector.tooltip':
        'It registers spots of interest in your space and it observes user interaction with them in order to trigger future adoption.',
    'Guides.menuItem.error.collector': 'Error Collector',
    'Guides.menuItem.error.collector.tooltip':
        'It observes frontend space error and validation messages and it reports it back to the space owner in order to take actions to decrease error rate production.',
    'Guides.menuItem.application.augmentation': 'Tooltips',
    'Guides.menuItem.application.augmentation.tooltip':
        'Extends space user interface with additional elements like tooltips, pop-overs or content labels without the need to contact your IT and development.',
    'Guides.menuItem.publishToEnv': 'Publish to different environment',
    'Guides.menuItem.duplicateGuide': 'Duplicate guide',
    'Guides.menuItem.createRecording': 'Create capture',
    'Guides.menuItem.cancelGuide': 'Cancel guide',
    'Guides.menuItem.recording.download': 'Download',
    'Guides.menuItem.recording.generate': 'Generate',
    'Guides.pluginSetup.button.showConf': 'Show configuration',
    'Guides.pluginSetup.button.details': 'Details',
    'Guides.publishToDifferentEnv': 'Publish to different environment',
    'Guides.newDomainName': 'New host domain name',
    'Guides.oldDomainName': 'Old host domain',
    'Guides.selectApplication': 'Select space',
    'Guides.searchPlaceholder': 'Search for guide or description',
    'Guides.editForm.name': 'Guide name',
    'Guides.editForm.initialUrl': 'Initial URL of the webpage',
    'Guides.editForm.description': 'Description of the guide',
    'Guides.editForm.title': 'Edit guide details',
    'Guides.contentLanguage': 'Content language',
    'Guides.published': 'Published',
    'Guides.unpublished': 'Unpublished',
    'Guides.startAutomatically': 'Start the guide automatically',
    'Guides.delete.message': 'Do you really want to delete this guide?',
    'Guides.create.new.guide': 'Create guide',
    'Guide.credential.set.message': 'In case of login, use following credentials set',
    'Guide.rules.invisible': 'Invisible',
    'Guide.rules.disabled': 'Disabled',
    'Guide.rules.off': 'Off',
    'Guide.rules.noRulesAppliedEdit': 'Press add button to create new rule',
    'Guide.rules.noRulesApplied': 'No rules has been applied',

    // Journeys
    'Journeys.list.empty': 'Go ahead and create your first journey',
    'Journeys.search.placeholder': 'Search for  journey',
    'Journeys.create.journey': 'Create journey',
    'Journeys.edit.journey': 'Edit journey',
    'Journeys.identifier.placeholder': 'Type identifier without white spaces',
    'Journeys.title.placeholder': 'Type human readable title of the journey',
    'Journey.title': 'Title',
    'Journey.confirm.delete.dialog': 'Do you really want to delete this journey?',
    'Journey.visible.action.title': 'Action after journey is complete',
    'Journey.visible.action.options.noAction': 'No action',
    'Journey.visible.action.options.leaveTrackerVisible': 'Leave the journey tracker visible',
    'Journey.afterFinishTour.action.title': 'Action after a tour in a journey is complete',
    'Journey.afterFinishTour.action.options.noAction': 'No action',
    'Journey.afterFinishTour.action.options.openContextHelp': 'Open Context Help',

    // Context Help
    'ContextHelp.title': 'Context help',

    // Context Help/menu
    'ContextHelp.navigation.composition': 'Composition',
    'ContextHelp.navigation.settings': 'Settings',

    // Context Help/Composition
    'ContextHelp.tour.placeholder': 'Tour name',
    'ContextHelp.playlist.placeholder': 'Playlist name',
    'ContextHelp.journey.placeholder': 'Journey name',
    'ContextHelp.expansionPanel.tours': 'Tours',
    'ContextHelp.expansionPanel.playlists': 'Playlists',
    'ContextHelp.expansionPanel.journeys': 'Journeys',
    'ContextHelp.expansionPanel.articles': 'Articles',
    'ContextHelp.article.source': 'Article source',

    // Context Help/Settings
    'ContextHelp.tours': 'Tours',
    'ContextHelp.tours.matchUrlText': 'Include guide in Context help when URL matches',
    'ContextHelp.tours.matchUrlHelpText': 'If ticked this guide will be included in the Context help',
    'ContextHelp.tours.matchElement': 'Include guide in Context help when element is present',
    'ContextHelp.suppressVisibleGuides':
        'Suppress visible tours when started from Context Help or Journey Tracker',
    'ContextHelp.recommendedTours': 'Recommended tours',
    'ContextHelp.listOfRecommendedTours.placeholder': 'List of Recommended tours',
    'ContextHelp.playlists': 'Playlists',
    'ContextHelp.playlists.label': 'Button text',
    'ContextHelp.playlists.placeholder': 'View Playlists',
    'ContextHelp.listHeading': 'List Heading',
    'ContextHelp.listOfTours.placeholder': 'List of Tours',
    'ContextHelp.journeys': 'Journeys',
    'ContextHelp.listOfJourneys.placeholder': 'List of Journeys',
    'ContextHelp.progressTracker': 'Progress tracker',
    'ContextHelp.restartQuestion': 'Restart question',
    'ContextHelp.restartProgressQuestion.placeholder': 'Are you sure you want to restart the progress?',
    'ContextHelp.confirmRestart': 'Confirm restart',
    'ContextHelp.confirmRestart.placeholder': 'Yes',
    'ContextHelp.declineRestart': 'Decline restart',
    'ContextHelp.declineRestart.placeholder': 'No',
    'ContextHelp.launcher': 'Launcher',
    'ContextHelp.position': 'Position',
    'ContextHelp.placeholder': 'Placeholder',
    'ContextHelp.searchPlaceholder.label': 'Search placeholder',
    'ContextHelp.searchPlaceholder.placeholder': 'Search',
    'ContextHelp.results': 'Results',
    'ContextHelp.noResultsFound.label': 'No results',
    'ContextHelp.noResultsFound.placeholder': 'No results found',
    'ContextHelp.enable.notification': 'Enable success notification for finished tour',
    'ContextHelp.notification.text': 'Notification text',
    'ContextHelp.notification.text.placeholder':
        'You have successfully finished the tour. Please continue further in the journey.',
    'ContextHelp.articles': 'Articles',
    'ContextHelp.listOfArticlesHeading.placeholder': 'List of Articles',
    'ContextHelp.learnMoreOfArticle.label': 'Label for complete article',
    'ContextHelp.learnMoreOfArticle.placeholder': 'Learn more',
    'ContextHelp.guidanceControl': 'Guidance control',
    'ContextHelp.guidanceControl.enabled': 'Enable Guidance control',
    'ContextHelp.guidanceControl.attachment.title': 'The Guidance control will be displayed in',
    'ContextHelp.guidanceControl.attachment.options.contextHelp': 'Context Help',
    'ContextHelp.guidanceControl.attachment.options.step': 'Step',
    'ContextHelp.guidanceControl.attachment.options.contextHelpAndStep': 'Context Help and Step',
    'ContextHelp.guidanceControl.attachment.options.launcher': 'Launcher',
    'ContextHelp.guidanceControl.attachment.options.launcherAndStep': 'Launcher and Step',
    'ContextHelp.guidanceControl.attachment.options.everywhere': 'Everywhere',
    'ContextHelp.guidanceControl.labelOn': 'Label for the guidance turned on',
    'ContextHelp.guidanceControl.labelOn.placeholder': 'Guidance on',
    'ContextHelp.guidanceControl.labelOff': 'Label for the guidance turned off',
    'ContextHelp.guidanceControl.labelOff.placeholder': 'Guidance off',
    'ContextHelp.guidanceControl.persistence.title': 'Browser persistence',
    'ContextHelp.guidanceControl.persistence.options.browserRestart': 'Persist across browser restart',
    'ContextHelp.guidanceControl.persistence.options.currentSession': 'Keep only in current session',

    'Settings.accessDenied': 'Access denied',
    'Settings.errorGetRolloutPoliciesByMyOrganizations':
        'Error occured while getting rollout policies by my organizations',
    'Settings.errorGetRolloutPoliciesBySpaceId':
        'Error occured while getting rollout policies by space id',

    // Settings menu
    'Settings.navigation.general': 'General',
    'Settings.navigation.integration': 'Integration',
    'Settings.navigation.language': 'Language',
    'Settings.navigation.identity': 'Profile',
    'Settings.navigation.multitenancy': 'Multi Tenancy',
    'Settings.navigation.tracking': 'Tracking',
    'Settings.navigation.guideDefaults': 'Guide defaults',
    'Settings.navigation.access': 'Access',
    'Settings.navigation.security': 'Security',
    'Settings.navigation.selectorSystem': 'Selector system',
    'Settings.navigation.selectorDefaults': 'Selector defaults',
    'Settings.navigation.confusion': 'Confusion',
    'Settings.navigation.addOns': 'Add-ons',
    'Settings.navigation.audience': 'Audience',
    'Settings.navigation.theme': 'Theme',

    // Settings/Integration
    'Settings.integration.title.frameworkSupport': 'Framework support',
    'Settings.integration.message':
        'Integrating Adopt is as easy as placing a script into your space template. We recommend you to place it at the end, before closing BODY tag',
    'Settings.integration.browserExtension': 'Browser extension',
    'Settings.integration.message2':
        'Adopt is authoring tool that allows you to create virtual tours tailored for your space. In standard case when you have integrated Adopt by following steps above there is no need to worry anymore. But there are cases when you want to try out Adopt capabilities, you are not technically experienced and do not have means to integrate it yet. In such case please install Chrome Extension.',
    'Settings.integration.message3':
        'Adopt needs to know key information about internal components of your space in order to provide best integrated experience. Based on such information we provide you appropriate integration script.',
    'Settings.integration.message4':
        'If you secure Content Security Policy in your space, system or project, you have to include following configuration as well',
    'Settings.integration.checkBox.popups': 'Native popup windows or IFrames',
    'Settings.integration.checkBox.startFromIFrame': 'Start from IFrame',
    'Settings.integration.checkBox.enableEditorRedirect': 'Enable editor redirect',
    'Settings.integration.radioButton.genericApplication': 'Generic space',
    'Settings.integration.radioButton.customScript': 'Custom Script',
    'Settings.integration.radioButton.internetExplorer': 'Internet Explorer',
    'Settings.integration.checkBox.ifcNamespace': 'IFC Namespace',

    // Settings/Integration/Experiment without integration
    'Settings.experiment.title': 'Experiment with Adopt without integration',
    'Settings.experiment.message':
        'Adopt is authoring tool that allows you to create virtual tours tailored for your space. In standard case when you have integrated Adopt by following steps above there is no need to worry anymore. But there are cases when you want to try out Adopt capabilities, you are not technically experienced and do not have means to integrate it yet. In such case follow provided installation procedure.',
    'Settings.experiment.guidesList': 'list of tours',
    // Firefox
    'Settings.experiment.firefox.step1.text': 'Install FireFox Custom Style Script Add-on',
    'Settings.experiment.firefox.step2':
        'Copy Adopt script to the clipboard by clicking "COPY SCRIPT" button above',
    'Settings.experiment.firefox.step3a': 'Go to',
    'Settings.experiment.firefox.step3b': 'in your space',
    'Settings.experiment.firefox.step4': 'Open a tour in editor by clicking "OPEN IN EDITOR" button',
    'Settings.experiment.firefox.step5a': 'Once the editor is opened in new tab, click "js"',
    'Settings.experiment.firefox.step5b': 'button in FireFox address bar on the right side',
    'Settings.experiment.firefox.step6': 'Dialog opens where you need to enter the script',
    'Settings.experiment.firefox.step7': 'Press "+" button in the dialog',
    'Settings.experiment.firefox.step8a':
        'Paste the script from the clipboard into "Javascript code" text area and remove leading',
    'Settings.experiment.firefox.step8b': 'and trailing',
    'Settings.experiment.firefox.step8c': 'tags',
    'Settings.experiment.firefox.step9':
        'Enter URL address you see in the address bar into "URL Filter" field above the text area',
    'Settings.experiment.firefox.step10': 'Reload the page (by pressing F5 or browser reload button)',
    'Settings.experiment.firefox.step11': "Editor's page should reload and Adopt toolbar appears",

    // Settings/Language
    'Settings.language.applicationLocalization': 'Space localization',
    'Settings.language.languages': 'Languages',
    'Settings.language.localizationSource': 'Localization source',
    'Settings.language.message':
        'Adopt supports multilingual environment. In order to allow content editors to enter text in multiple languages, you have to specify them in the following section.',
    'Settings.language.message2':
        'By setting following localization information you notice Adopt where it should find localization preference in your space. It is space-wide setting that you can utilize inside any guide when you want to match guide language with language of your space.',
    'Settings.language.message3.1': 'Please, use',
    'Settings.language.message3.2':
        'to match the language pattern in URL. Language is identified by first capturing group identified by parentheses. Sample: <<app_domain>>/(.*) will match "en" language from <<app_domain>>/en URL',
    'Settings.language.translations': 'Translations',
    'Settings.language.message4':
        'If you would like to translate the content of your steps in guides in a batch, this is the way to go. We support custom CSV & MS Excel XLSX formats at the moment. These do not preserve HTML formatting. Keep that in mind when re-importing.',
    'Settings.language.withPath': 'with path',
    'Settings.language.label': 'Type language you want to support',
    'Settings.language.label2': 'Localization is identified by',
    'Settings.language.label3': 'Path',
    'Settings.language.readFrom': 'Read language from',
    'Settings.language.readFromBrowser': 'browser',
    'Settings.language.readFromApplicationSettings': 'space settings',
    'Settings.language.fallback': 'Fallback Language',
    // Menu
    'Settings.language.menu.adopt': 'Adopt',
    'Settings.language.menu.adopt.excel': 'Adopt Excel',
    'Settings.language.menu.adopt.csv': 'Adopt CSV',

    // Settings/General
    'Settings.general.applicationDetail': 'Space detail',
    'Settings.general.name': 'Name',
    'Settings.general.domains': 'Extension URLs',
    'Settings.general.extensionUrls.options.notSet': '(Not set)',
    'Settings.general.rolloutPolicy': 'Rollout Policy',
    'Settings.general.inaccessible': 'Inaccessible',
    'Settings.general.trustedDomains': 'Trusted Domains',
    'Settings.general.extensionUrls.message':
        '* Updating extension URLs might take up to few minutes to have an effect.',
    'Settings.general.trustedDomains.message':
        '* Updating trusted domains might take up to few minutes to have an effect.',
    'Settings.general.avatar': 'Avatar',
    'Settings.general.upload': 'Upload',
    'Settings.general.message':
        'We would like to warn you before you take this action. Once you delete the space all its guides, segments, facts and related data will be removed as well.',
    'Settings.general.label': 'Adopt',
    'Settings.general.label2': 'Type regex pattern for the url that will load for this space',
    'Settings.general.label3': 'Enter a trusted domain',
    'Settings.general.label4': 'Needs to contain correct domain format',
    'Settings.general.duplicateApplication': 'Clone space',
    'Settings.general.duplicateApplication.message':
        'Pressing the Perform button duplicates the space with all settings and guides.',
    'Settings.general.id': 'ID',
    'Settings.general.companyid': 'Company ID',

    // Settings/Access
    'Settings.access.userAccess': 'User access',
    'Settings.access.message': 'Here is where you grant your administrative users access to this space.',
    'Settings.access.owner': 'Owner',
    'Settings.access.users': 'Users',
    'Settings.access.label': 'Hint text',
    'Settings.access.emptyList': 'List is empty',
    'Settings.access.label2': 'Read',
    'Settings.access.inviteUsers': 'Invite new users',
    'Settings.access.message2':
        'Here’s where you invite new users to participate in the space. These users do not yet have Adopt account and therefore need to be registered. Feel free to type an email of next contributors and invite them.',
    'Settings.access.invite.placeholder': 'Contributor email',
    'Settings.access.presets': 'Presets',

    // Settings/Identity
    'Settings.identity.identityAndUserProfile': 'User Profile',
    'Settings.identity.message':
        'By setting following profile information you notice Adopt where it should find user identifier and role assignment in your space. It is space-wide setting that you can utilize inside any guide when you want to decide for which user or which role the guide should be visible.',
    'Settings.identity.label': 'Logged in users are identified by',
    'Settings.identity.label2': 'Role of the user is identified by',
    'Settings.identity.label3': 'Path',
    'Settings.identity.helperText': '*(Cookies with Http Only flag set to true will not work)',

    // Settings/Multi Tenancy
    'Settings.multitenancy.multiTenancy': 'Multi Tenancy',
    'Settings.multitenancy.message':
        'If you have a multi-tenant space and if you would like to use the same guides on multiple domains such as tenant-a.your-domain.com and tenant-b.your-domain.com, you can specify a pattern that matches the distinguishing part of the URL here. Setting up the correct pattern saves your time, because you do not need to create separate guides for each domain. You just create guides on one tenant, and we will handle the rest.',
    'Settings.multitenancy.label': 'Pattern',

    // Settings/Selector system
    'Settings.selectorSystem.title': 'Element selectors',
    'Settings.selectorSystem.message':
        "Selector system allows you to influence how Adopt understands your space's internal rendering structure (for technical people - DOM tree). In order to record sustainable onboarding we need further instructions in certain cases.",
    'Settings.selectorSystem.classOnly.title': "Selector 'class only'",
    'Settings.selectorSystem.classOnly.message':
        'This selector is constructed only from CSS class names',
    'Settings.selectorSystem.message.1':
        'Element selectors are responsible for localizing space elements in unique way. Adopt records multiple types of selectors in order to increase the chance to find the element.',
    'Settings.selectorSystem.message.2':
        'Adopt is able to detect dynamically generated identifiers and treat them properly. Let\'s have an example where you have dynamically generated class names in Angular for particular element, e.g. <div class="ng-123"/>, <div class="ng-345"/>, ... But we can go even further, we take all classes that are prefixed with something like <b>ng-</b> or <b>col-</b> and treat them properly using this configuration:',
    'Settings.selectorSystem.message.3': 'Pattern = (.+?)(?:[-].*)',
    'Settings.selectorSystem.message.4': 'Replacer = [class*=$1]',
    'Settings.selectorSystem.label': 'Pattern',
    'Settings.selectorSystem.label2': 'Replacer',
    'Settings.selectorSystem.classNameBlacklist.title': 'Ignored element class names',
    'Settings.selectorSystem.classNameBlacklist.message':
        'This is the list of comma-separated class names of elements that should be excluded from construction of the selector.',
    'Settings.selectorSystem.classNameBlacklist.placeholder': 'Comma-separated list of class names',
    'Settings.selectorSystem.idBlacklist.title': 'Ignored element IDs',
    'Settings.selectorSystem.idBlacklist.message':
        'This is the list of comma-separated identifiers of elements that should be excluded from construction of the selector.',
    'Settings.selectorSystem.idBlacklist.placeholder': 'Comma-separated list of identifiers',
    'Settings.selectorSystem.customWhitelist.title': 'Included element custom attribute names',
    'Settings.selectorSystem.customWhitelist.message':
        'This is the list of comma-separated custom attribute names of elements that should be included in construction of the selector.',
    'Settings.selectorSystem.customWhitelist.placeholder': 'Comma-separated list of attribute names',
    'Settings.selectorSystem.excludedLocations.placeholder': 'CSS selector',
    'Settings.selectorSystem.excludedLocations.title': 'Dropdown list selector',

    // Settings/Selector defaults
    'Settings.selectorDefaults.title': 'Element Selector Overrides',
    'Settings.selectorDefaults.message':
        'Here you can set which Element Locations you want to <strong>disable</strong> by default during selector creation. To <strong>disable</strong>, tick the required selectors from the list below. Changes here will be reflected in new selections only. The defaults will be applied to all places where you can pick an element.',

    // Settings/Tracking
    'Settings.tracking.userBehaviour': 'User behaviour tracking',
    'Settings.tracking.experimental': 'experimental',
    'Settings.tracking.message':
        'If you want to enable experimental behaviour tracking used for guide generation and user confusion analysis, click Enable button and select tracking options. For events "keyup" and "keydown" we do not track the pressed key',
    'Settings.tracking.message2':
        'Default values for sampling rate is 16 (~60fps) and batch interval is 1000 (ms). Set schedule to only track user behaviour in desired time interval. The format of schedule is start-end, where start and end are hours (ie. schedule value 10-14 tracks user activity between 10:00-14:00)',
    'Settings.tracking.events': 'Tracked events',
    'Settings.tracking.label': 'Sampling rate',
    'Settings.tracking.label2': 'Batch sending interval (milliseconds)',
    'Settings.tracking.label3': 'Schedule (start-end)',
    'Settings.tracking.event.click': 'click',
    'Settings.tracking.event.mousemove': 'mousemove',
    'Settings.tracking.event.scroll': 'scroll',
    'Settings.tracking.event.mousedown': 'mousedown',
    'Settings.tracking.event.mouseup': 'mouseup',
    'Settings.tracking.event.keydown': 'keydown',
    'Settings.tracking.event.keyup': 'keyup',
    'Settings.tracking.whitelist': 'URL whitelist',
    'Settings.tracking.label4': 'Pattern',

    // Settings/Confusion
    'Settings.confusion.title': 'Predict the confusion of users',
    'Settings.confusion.label': 'Model type',
    'Settings.confusion.modelId.label': 'Model ID',
    'Settings.confusion.modelUrls.placeholder': 'URLs',
    'Settings.confusion.confusionTimeoutSeconds': 'Confusion timeout (seconds)',
    'Settings.confusion.reaction.label': 'Confusion reaction',
    'Settings.confusion.reaction.openConfusionDialog': 'Help dialog',
    'Settings.confusion.reaction.shakeContextHelp': 'Shake context help',
    'Settings.confusion.reaction.none': 'Do not act',
    'Settings.confusion.reaction.numberOfShakes': 'Number of shakes',
    // Generate guide
    'Settings.confusion.guideGeneration.title': "Guide generation based on user's behaviour",
    'Settings.confusion.guideGeneration.idType.label': 'ID type',
    'Settings.confusion.guideGeneration.ids.floatingLabelText': 'Id value',
    'Settings.confusion.guideGeneration.urls.floatingLabelText': 'URL value',
    'Settings.confusion.guideGeneration.minNumOfExperts.floatingLabelText': 'Minimum experts support',
    'Settings.confusion.guideGeneration.maxNumOfGuides.floatingLabelText': 'Maximum number of guides',
    'Settings.confusion.guideGeneration.modelType.label': 'Model type',
    'Settings.confusion.guideGeneration.preset.label': 'Preset',
    'Settings.confusion.guideGeneration.preset.customValues': 'Custom values',
    'Settings.confusion.guideGeneration.preset.daySplit': 'Day split',
    'Settings.confusion.guideGeneration.preset.breakSplit': 'Activity break split',
    'Settings.confusion.guideGeneration.preset.sequenceSplit': 'Sequence split',
    'Settings.confusion.guideGeneration.sequenceMiner.label': 'Sequence miner strategy',
    'Settings.confusion.guideGeneration.maxStepsInSequence.floatingLabelText':
        "Max elements of user's interaction",
    'Settings.confusion.guideGeneration.timeThreshold.floatingLabelText':
        'Max time between user interactions in his sequence',
    'Settings.confusion.guideGeneration.EGGv3Control':
        'Attention: Selected model type requires EGG extension enabled!',

    // Settings/Guide defaults
    'Settings.defaults.guideDefaults': 'Guide defaults',
    'Settings.defaults.message':
        'Here you can set the default values for steps in your guides. Changes here will be reflected in newly created guides only.',
    'Settings.defaults.nodeDefaults': 'Overlay Defaults',
    'Settings.defaults.navigate': 'Navigate to URL address when step is shown',
    'Settings.defaults.ignoreNavigation': 'Ignore URL address',
    'Settings.defaults.ignoreQueryParameters': 'Ignore recorded query parameters',
    'Settings.defaults.scrollToStep': 'Scroll to view element',
    'Settings.defaults.notCovered': 'Display step when element is not covered',
    'Settings.defaults.pathDefinition': 'Element path definition setup',
    'Settings.defaults.updateOnScroll': 'Enable position recalculation when user scrolls',
    'Settings.defaults.label': 'Scrolling container location',

    // Settings/Theme
    'Settings.theme.titlePage': 'Space theme',
    'Settings.theme.message':
        'The space theme will be implemented for Adopt parts such as context help, journey tracker or progress tracker. For the guide, the theme can still be set separately in the Adopt editor.',
    'Settings.theme.applicationTheme': 'Selected space theme',
    'Settings.theme.themeVariant.title': 'Theme variants',
    'Settings.theme.themeVariant.message':
        'The underlying system can dynamically change its look and feel be it between light or dark variant. Adopt should be aware of that change and react with a modified theme so the user experience is great. Therefore you need to instruct Adopt where to find the information about the type of the theme variant.',
    'Settings.theme.variantEnabled': 'Variants enabled',
    'Settings.theme.variantIdentifiedBy': 'Variant identified by',
    'Settings.theme.withPath': 'with path',
    'Settings.theme.withPath.placeholder': 'Hint text',
    'Settings.theme.fallbackVariantValue': 'Fallback variant value',
    'Settings.theme.fallbackVariantValue.placeholder':
        'Provide the name of the theme variant used as the fallback',
    'Settings.theme.options.localStorage': 'Local Storage',
    'Settings.theme.options.notSet': '(Not set)',
    'Settings.theme.options.cookie': 'Cookie',
    'Settings.theme.options.jsVariable': 'Javascript Value',
    'Settings.theme.options.cssPath': 'CSS Selector',
    'Settings.theme.options.urlQuery': 'URL Query',

    // Settings/Add-ons
    'Settings.addOns.title': 'Active add-ons',
    'Settings.addOns.message':
        'Here is where you activate Adopt add-ons for the space. Add-ons extend the functionality of base Adopt platform with third party systems.',
    'Settings.addOns.input.placeholder': 'Search for an add-on',
    'Settings.addOns.input.label': 'Add-on, which they are available',
    // Add-on detail
    'Settings.addOn.detail.title': 'Add-on detail',
    'Settings.addOn.detail.vendor': 'Vendor',
    'Settings.addOn.detail.systemKey': 'System key',
    'Settings.addOn.detail.description': 'Description',
    'Settings.addOn.detail.description.placeholder': 'Integration of Segment.com service into...',
    'Settings.addOn.detail.expansionPanel.configuration': 'Adopt Configuration',
    'Settings.addOn.detail.authentication': 'Authentication',
    'Settings.addOn.detail.username': 'Username',
    'Settings.addOn.detail.password': 'Password',
    'Settings.addOn.detail.clientID': 'Client ID',
    'Settings.addOn.detail.clientSecret': 'Client secret',
    'Settings.addOn.detail.apiKey': 'Api Key',
    'Settings.addOn.detail.expansionPanel.addOnSpecificConfiguration': 'Add-on specific Configuration',

    // Settings/Audience
    'Settings.audience.resetAll.title': 'Reset all rule facts',
    'Settings.audience.resetAll.message':
        'By clicking on the button you can reset all the facts in your space.',
    'Settings.audience.confirmDialog': 'Do you want to delete all facts for selected space?',
    'Settings.audience.resetFactsForUser.title': 'Reset all rule facts for user',
    'Settings.audience.resetFactsForUser.message':
        'By clicking on the button you can reset all the facts  for particular user',
    'Settings.audience.resetFactsForUser.form': 'Please, enter the user ID for fact deletion:',

    // Audit
    'Audit.title': 'Audit log',
    'Audit.table.time': 'Time',
    'Audit.table.event': 'Event type',
    'Audit.table.userName': 'User name',
    'Audit.table.ipAddress': 'IP Address',
    'Audit.table.result': 'Result',
    'Audit.fail.loadData': 'Unable to load data, something went wrong',

    // Accounts
    'Accounts.title': 'Accounts',

    // Invite section
    'Applications.createNewApp.invite': 'Invite',
    'Applications.createNewApp.message':
        'Here’s where you invite new users to participate in the space. These users do not yet have Adopt account and therefore need to be registered. Feel free to type an email of next contributors and invite them.',
    'Application.createNewApp.placeholder': 'Contributor email',

    // Segments
    'Segments.createSegmentTitle': 'Create segment',
    'Segments.editSegmentTitle': 'Edit segment',
    'Segments.search.placeholder': 'Search for a segment',
    'Segments.createSegment.kind': 'Kind',
    'Segments.createSegment.valueType': 'Value type',
    'Segments.createSegment.name': 'Name',
    'Segments.createSegment.systemKey': 'System key',
    'Segments.createSegment.description': 'Description',
    'Settings.createSegment.placeholder': 'Hint text',
    'Settings.createSegment.message1':
        'User Collected segment is stored in analytics database.It is shared across your organization.',
    'Settings.createSegment.message2':
        'User Frontend segment is available only in space’s frontend and it is not stored in analytics database. Value of the segment is evaluated on in the target space.',
    'Settings.createSegment.message3':
        'Adopt is capable of gathering System Collected segment. If you select one, it will be activated in the space and stored in analytics database.',

    // Themes
    'Themes.title': 'Themes',
    'Themes.search.placeholder': 'Search for a theme',

    // Theme Form
    'Themes.edit.title': 'Edit theme',
    'Theme.edit.name': 'Name',
    'Theme.edit.name.placeholder': 'Clone of Modern Inverted',
    'Theme.edit.background': 'Background',
    'Theme.edit.primaryColor': 'Primary Color',
    'Theme.edit.secondaryColor': 'Secondary Color',
    'Theme.edit.imageAddress': 'Image address',
    'Theme.edit.font': 'Font',
    'Theme.edit.fontFamily': 'Font family',
    'Theme.edit.fontColor': 'Font color',
    'Theme.edit.titleColor': 'Title color',
    'Theme.edit.step': 'Step',
    'Theme.edit.depth': 'Depth',
    'Theme.edit.navigation': 'Navigation',
    'Theme.edit.navigation.primaryColor': 'Primary Color',
    'Theme.edit.navigation.secondaryColor': 'Secondary Color',
    'Theme.edit.shadow': 'Shadow',
    'Theme.edit.color': 'Color',
    'Theme.edit.shadow.depth': 'Depth',
    'Theme.delete.message': 'Do you really want to delete this theme?',
    'Theme.edit.error': 'System error occurred.',

    // AccountNotifications
    'AccountNotifications.title': 'Notifications',
    // Table
    'AccountNotification.timestamp': 'Timestamp',
    'AccountNotification.subject': 'Subject',
    'AccountNotification.message': 'Message',
    'AccountNotification.type': 'Type',

    // Tables
    'Tables.performance.guideName': 'Guide name',
    'Tables.performance.visitorsStarted': 'Visitors started',
    'Tables.performance.visitorsFinished': 'Visitors finished',
    'Tables.performance.usersStarted': 'Users started',
    'Tables.performance.usersFinished': 'Users finished',

    'Tables.funnel.guideName': 'Guide',
    'Tables.funnel.state': 'State',
    'Tables.funnel.absolute': 'Absolute',
    'Tables.funnel.relative': 'Relative',

    'Tables.triggers.guideName': 'Guide name',
    'Tables.triggers.stepName': 'Step name',
    'Tables.triggers.triggerName': 'Trigger name',
    'Tables.triggers.count': 'Count',

    'Tables.accounts.userName': 'Username',
    'Tables.accounts.fistName': 'First name',
    'Tables.accounts.lastName': 'Last name',
    'Tables.accounts.email': 'Email',
    'Tables.accounts.verified': 'Verified',
};
